import { checkNonContender } from './checkNonContender.js'
import logger from './logger.js';

function calculateNewEstimate(values) {

    const { condition, price_prediction, make, modelYear, mileage, enginePower, fuelType } = values    

    const rules = [
        {
            manufacturers: ['Volvo', 'Renault', 'Ford', 'Dacia'],
            ranges: [
                {
                    from: 0,
                    to: 399999,
                    deduction: .10,
                    min: 18000,
                    max: 35000
                },
                {
                    from: 400000,
                    to: Infinity,
                    deduction: 0.15,
                    min: 0,
                    max: Infinity
                }

            ]
        },
        {
            manufacturers: ['BMW', 'Audi', 'Mercedes', 'Mercedes-Benz'],
            ranges: [
                {
                    from: 0,
                    to: 399999,
                    deduction: .10,
                    min: 18000,
                    max: 35000
                },
                {
                    from: 400000,
                    to: Infinity,
                    deduction: 0.15,
                    min: 0,
                    max: Infinity
                }

            ]
        },
        {
            manufacturers: null,
            ranges: [
                {
                    from: 0,
                    to: 399999,
                    deduction: .10,
                    min: 18000,
                    max: 35000
                },
                {
                    from: 400000,
                    to: Infinity,
                    deduction: 0.15,
                    min: 0,
                    max: Infinity
                }

            ]
        }
    ]

    /**
     * Car is to old and has too much mileage
     * for a fair pricing.
     */
         
    if (checkNonContender(modelYear, mileage, enginePower, fuelType, price_prediction)) {
        logger('Car is non-contender');
        return false;
    } else {
        logger('Car is can be valued');
    }

    var deductionValue = 0;

    rules.some(rule => {
        if (rule.manufacturers === null || rule.manufacturers.includes(make)) {
            logger('Is in rule ' + (rule.manufacturers === null ? 'null' : rule.manufacturers.join(', ')));
            rule.ranges.some(range => {
                if (range.from <= price_prediction && price_prediction <= range.to) {
                    logger('Is in range from:' + range.from + ' to:' + range.to);
                    // Percentage or fixed value
                    let tmpDeduction = Number.isInteger(range.deduction)
                        ? range.deduction
                        : price_prediction * range.deduction;

                    // Check deduction min max values
                    deductionValue = Math.max(Math.min(tmpDeduction, range.max), range.min);
                    logger('Predicted:' + price_prediction);
                    logger('Deduction value:' + deductionValue);
                    return true
                }
                return false
            })
            return true
        }
        return false

    })

    const blanketPriceDeduction = 0;

    let conditionDeduction = {
        'Mycket bra skick': 8000,
        'Bra skick': 12000,
        'Helt ok skick': 16000,
        'Dåligt skick': 24000,
    }
    let conditionDeductionValue = conditionDeduction[condition] || 0;

    // Calc price from deductions
    const price = (price_prediction - (deductionValue + conditionDeductionValue + blanketPriceDeduction));
    logger('Condition deduction: ' + conditionDeductionValue);
    logger('Blanket deduction: ' + blanketPriceDeduction);
    logger('Total deduction: ' + (deductionValue + conditionDeductionValue + blanketPriceDeduction));

    // return price or false if price is negative
    // false is used to indicate that the car is a non-contender
    return price > 0 ? price : false;
}

export default calculateNewEstimate